import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MobileBreakpointService } from 'src/app/services/mobile-breakpoint.service';
import { SidenavService } from 'src/app/services/sidenav.service';

interface NavItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('sidenav') sidenav?: MatSidenav;
  @Input() hideSidenav: boolean = false;
  isCollapsed: boolean = false;
  isMobile: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private sidenavService: SidenavService,
    private mobileBreakpointService: MobileBreakpointService
  ) {}

  ngOnInit(): void {
    this.checkIfSidenavIsCollapsed();
    this.checkIfIsMobile();
  }

  private checkIfSidenavIsCollapsed(): void {
    this.sidenavService.collapsedSidenav$
      .pipe(takeUntil(this.destroy$))
      .subscribe((collapsed) => {
        this.isCollapsed = collapsed;
      });
  }

  private checkIfIsMobile(): void {
    this.mobileBreakpointService.isMobile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
      });
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle(): void {
    this.sidenav?.toggle();
  }

  open(): void {
    this.sidenav?.open();
  }

  close(): void {
    this.sidenav?.close();
  }

  toggleCollapse(): void {
    if (!this.isMobile) {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  onToggleClick(): void {
    if (this.isMobile) {
      this.sidenavService.close();
    } else {
      this.sidenavService.toggleCollapse();
    }
  }

  getToggleIcon(): string {
    if (this.isMobile) {
      return 'close';
    }
    return this.isCollapsed ? 'menu' : 'menu_open';
  }

  getToggleTooltip(): string {
    if (this.isMobile) {
      return 'Fechar a barra lateral';
    }
    return this.isCollapsed
      ? 'Expandir a barra lateral'
      : 'Recolher a barra lateral';
  }
}
